// PRD.275 — Elia AI Assistant Drawer (Phase 1, UI only).
//
// Global top-right trigger (FR-1). Feature-gated: renders nothing when Elia is
// disabled. Uses the Elia pink treatment and reflects open/selected state.

import { ELIA_COLORS } from './elia-theme';
import { EliaAvatar } from './EliaAvatar';
import { useEliaAi } from './EliaAiProvider';

export function EliaAiTrigger() {
  const { enabled, isOpen, toggle } = useEliaAi();
  if (!enabled) return null;

  return (
    <button
      type="button"
      aria-label="Open Elia AI"
      aria-haspopup="dialog"
      aria-expanded={isOpen}
      title="Elia AI — your clinic assistant"
      onClick={toggle}
      style={{
        width: 36,
        height: 36,
        borderRadius: '9999px',
        border: 'none',
        background: isOpen ? ELIA_COLORS.pinkSoft : 'transparent',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        padding: 0,
        flexShrink: 0,
      }}
      onMouseEnter={(e) => {
        if (!isOpen) {
          (e.currentTarget as HTMLElement).style.background = ELIA_COLORS.pinkSoft;
        }
      }}
      onMouseLeave={(e) => {
        if (!isOpen) {
          (e.currentTarget as HTMLElement).style.background = 'transparent';
        }
      }}
    >
      <EliaAvatar size={28} />
    </button>
  );
}
